import checkDevice from './checkDevice';

const deepLinkAction = {
  CLOSE_WEBVIEW: 'browser/close',
  WATCH_LIVE: 'player/live',
  WATCH_VOD: 'player/video',
  NAVIGATE_BROWSER: 'browser/station',
};

export const objectToQueryString = (obj) => {
  if (obj === undefined) return '';
  const queryString = Object.keys(obj)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&');
  return `?${queryString}`;
};

export const deepLinkHandler = (action, ...params) => {
  const queryString = objectToQueryString(params[0]);

  location.href = `sooplive://${deepLinkAction[action]}${queryString}`;
};

export const bridgeHandler = (action, params) => {
  const device = checkDevice();
  if (device === 'Android') {
    if (action === 'THROW_TOAST' && params) {
      window.SoopiBridge.throwToast(params.msg);
    } else if (action === 'OPEN_BROWSER' && params) {
      window.SoopiBridge.openBrowser(params.url);
    }
  } else {
    if (action === 'THROW_TOAST' && params) {
      window.webkit.messageHandlers.throwToast.postMessage(params.msg);
    } else if (action === 'OPEN_BROWSER' && params) {
      window.webkit.messageHandlers.openBrowser.postMessage(params.url);
    }
  }
};
